import { OnInit, Component, DoCheck, KeyValueDiffers, HostListener, ViewChild, TemplateRef } from '@angular/core';
import { first} from 'rxjs/operators';
import { User} from '../../../_models';
import { CategoryService } from '../../../_services/category.service';
import { UserService } from '../../../_services/user.service'
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, FormArray, FormGroup, FormControl } from '@angular/forms';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import cloneDeep from 'lodash/cloneDeep';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { VirtualFolderService } from 'src/app/_services/virtualFolder.service';

@Component({
  selector: 'app-redaction-mapping',
  templateUrl: './redaction-mapping.component.html',
  styleUrls: ['./redaction-mapping.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class RedactionMappingComponent implements OnInit {
  redactionMappingTableArray = [];
  redactionMappingDataSource = new MatTableDataSource(this.redactionMappingTableArray);

  isAdmin: boolean = false;
  currentUser: User;
  userGroups: string[];

  displayedColumns: string[] = ['catName', 'redactedCatName', 'redactionProfile', 'confidenceLevel', 'forceReview', 'actions'];
  
  enableNewMappingPage: boolean = false;
  enableUpdateMappingPage: boolean = false;
  
  selectedMappingForEdit = null;
  mappingForm: FormGroup;
  
  button: string = 'Save';

  allCategories;
  filteredCategories;
  redactedCategories;
  filteredRedactedCategories;
  filteredReviewVirtualFolders;
  redactionProfiles = [];
  filteredRedactionProfiles;
  
  differ: any;

  redactedCategoryName: string = '';
  //reviewCategoryName: string = '';
  redactionProfileSearch: string = '';
  reviewVirtualFolderSearch: string = '';
  categorySearch: string = '';


  //PERMISSIONS
  commonPermissions: string[]
  permissionsList: string[] = ["Add Document", "Update Document", "Delete Document", "View Document", "Get Document", "Create Category", "Get Category", "Update Category", "Delete Category", "Compliance", "Redact Document"]
  permissionsListForValidations: string[] = ["add_document", "update_document", "delete_document", "view_document", "get_document", "create_category", "get_category", "update_category", "delete_category", "compliance", "redact_document"];
  permissionName: string

  copiedGroups: string[]
  copiedGroupsForCat: string = null;

  trialArray = [ 1, 2, 3];
  usersList = [];
  displaySubCatPerms =  true;

  mappingToBeDeleted = null;

  deleteMappingPopupRef = null;
  allVirtualFolderList = [];
  searchCtrl;
  @ViewChild('deleteMappingPopup', { static: false }) deleteMappingPopup: TemplateRef<any>;
  constructor(  
    private categoryService: CategoryService,
    private virtualFolderService: VirtualFolderService,
    private userService: UserService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private usersGroupsService: UsersAndGroupsService,
    private differs: KeyValueDiffers) {
       this.differ = this.differs.find({}).create();
     }

  async ngOnInit() {
    this.allVirtualFolderList = await this.virtualFolderService.getTree().toPromise();
    this.redactionMappingTableArray = (await this.categoryService.getCategoryMapping().toPromise())['Entities'];
    this.allCategories = (await this.categoryService.getAll().toPromise())['results'];
    this.redactionProfiles = (await this.categoryService.getRedactionProfilesList().toPromise())['Entities'];
    this.addCategoryNamesToMappingTable(); 
    this.redactionMappingDataSource = new MatTableDataSource([...this.redactionMappingTableArray]);
   

    this.filteredRedactedCategories = cloneDeep(this.redactedCategories);
    this.filteredReviewVirtualFolders = cloneDeep(this.allVirtualFolderList);
    this.filteredRedactionProfiles = cloneDeep(this.redactionProfiles);
    this.filteredCategories = cloneDeep(this.allCategories);
    console.log(this.filteredReviewVirtualFolders);
    console.log(this.filteredCategories, this.redactionMappingTableArray);
   
    this.userService.getAll().pipe(first()).subscribe(usersList => { this.usersList = usersList; });

    if (this.userGroups != null) {
      var adminGroup
      this.usersGroupsService.getAdminGroupName().subscribe(admin => {
        adminGroup = admin
        console.log(admin, this.userGroups);
        for (let i = 0; i < this.userGroups.length; i++) {
          console.log(this.userGroups[i]);
          //if (group.match(adminGroup)) {
          if (adminGroup.indexOf(this.userGroups[i]) >= 0) {
            this.isAdmin = true;
            break;
          }
        }
      })
    }
  }

  addCategoryNamesToMappingTable() {
    let tempRedactCategoriesArray = [];
    for(let i = 0; i < this.redactionMappingTableArray.length; i++) {
      let tempParentCat = this.allCategories.find(ele => ele['id'].toString() == this.redactionMappingTableArray[i]['Category Id']);
      let tempRedactCat = this.allCategories.find(ele => ele['id'].toString() === this.redactionMappingTableArray[i]['redactDestId']);
      let tempRedactProfile = this.redactionProfiles.find(ele => ele['Profile ID'].toString() === this.redactionMappingTableArray[i]['Redaction Profile ID'])
      if(tempParentCat != undefined) {
        this.redactionMappingTableArray[i]['catName'] = tempParentCat['name'];
      }
      if(tempRedactCat != undefined) {
        this.redactionMappingTableArray[i]['redactedCatName'] = tempRedactCat['name'];
      }
      if(tempRedactCat != undefined) {
        this.redactionMappingTableArray[i]['redactionProfile'] = tempRedactProfile['Profile Name'];
      }

      let vfIds = [];
      vfIds = this.redactionMappingTableArray[i]['Review ID'].split(',');
      console.log(vfIds);
      for(let j = 0; j < vfIds.length; j++) {
        j === 0 ? this.redactionMappingTableArray[i]['parentVfId'] = vfIds[j] : j === 1 ? this.redactionMappingTableArray[i]['redactedVfId'] = vfIds[j] : this.redactionMappingTableArray[i]['reviewVfId'] = vfIds[j];
      }
    }

    // for(let i = 0; i < this.allCategories.length; i++) {
    //   if(this.allCategories[i]['name'].includes('Redacted')) {
    //     if(!tempRedactCategoriesArray.includes(this.allCategories[i])) {
    //       tempRedactCategoriesArray.push(this.allCategories[i]);
    //     }
    //   } 
    // } 

    this.redactedCategories = [...this.allCategories];
  }
  
  ngDoCheck() {
    const change = this.differ.diff(this);
    if (change) {
      change.forEachChangedItem(item => {
        if (item['key'] == 'copiedGroupsForCat') {
          this.commonPermissions = [];
        }

        if (item['key'] == 'redactedCategoryName') {
          if(item['currentValue'] != undefined) {
            this.filteredRedactedCategories = this.filterRedactedCategories(item['currentValue'])
          } else if(item['currentValue'] == undefined && item['previousValue'] != undefined) {
            this.redactedCategoryName = item['previousValue'];
          }          
        }

        if (item['key'] == 'reviewVirtualFolderSearch') {
          if(item['currentValue'] != undefined) {
            this.filteredReviewVirtualFolders = this.filterReviewVirtualFolders(item['currentValue'])
          } else if(item['currentValue'] == undefined && item['previousValue'] != undefined) {
            this.reviewVirtualFolderSearch = item['previousValue'];
          }          
        }

        if (item['key'] == 'redactionProfileSearch') {
          if(item['currentValue'] != undefined) {
            this.filteredRedactionProfiles = this.filterRedactionProfiles(item['currentValue'])
          } else if(item['currentValue'] == undefined && item['previousValue'] != undefined) {
            this.redactionProfileSearch = item['previousValue'];
          }          
        }

        if (item['key'] == 'categorySearch') {
          if(item['currentValue'] != undefined) {
            this.filteredCategories = this.filterAllCategories(item['currentValue'])
          } else if(item['currentValue'] == undefined && item['previousValue'] != undefined) {
            this.categorySearch = item['previousValue'];
          }          
        }
      });
    }
  }
  

  enableNewMapping(action, selectedMappingObj?) {
    if (action == 'new') {
      this.enableNewMappingPage = true;
      this.enableUpdateMappingPage = false;
      this.initiateNewForm();
      this.button = 'Save';
    } else if (action == 'update') {
      console.log(selectedMappingObj);
      this.enableUpdateMappingPage = true;
      this.enableNewMappingPage = false;
      this.selectedMappingForEdit = cloneDeep(selectedMappingObj);
      this.initiateNewForm();
      this.initiateUpdateForm(selectedMappingObj);
      console.log(this.mappingForm);
      this.button = 'Update';
    }
  }
  
  initiateNewForm(): void {
    this.mappingForm = this.fb.group({
      category: new FormControl(null, Validators.required),
      redactedCategory: new FormControl(null, Validators.required),
      redactionProfile: new FormControl(null, Validators.required),
      confidenceLevel: new FormControl('', [Validators.required, Validators.max(100), Validators.min(50)] ),
      forceReview: new FormControl(true, Validators.required),
      reviewVirtualFolder: new FormControl(null, Validators.required),
    })
  }

  initiateUpdateForm(selectedMappingObj?) {
    console.log(selectedMappingObj)
    let tempCat = this.filteredCategories.find(ele => ele['name'] === selectedMappingObj['catName'])
    let tempRedactedCat = this.filteredRedactedCategories.find(ele => ele['name'] === selectedMappingObj['redactedCatName'])
    //let tempReviewCat = this.filteredReviewCategories.find(ele => ele['name'] === selectedMappingObj['reviewCatName']);
    let redactionProfile = this.filteredRedactionProfiles.find(ele => ele['Profile Name'] === selectedMappingObj['redactionProfile']);
    let reviewVirtFolder = this.filteredReviewVirtualFolders.find(ele => ele['id'] == selectedMappingObj['parentVfId'])
console.log(this.filteredReviewVirtualFolders, reviewVirtFolder)
    let redactPermParentCat = tempCat['permissions']['redact_document'] != undefined ? tempCat['permissions']['redact_document'] : [];
    let redactPermRedactCat = tempRedactedCat['permissions']['redact_document'] != undefined ? tempRedactedCat['permissions']['redact_document'] : [];

    let data = {
      category: tempCat,
      redactedCategory: tempRedactedCat,
      //reviewCategory: tempReviewCat,
      redactionProfile: redactionProfile,
      //copyParentPermissions: false,
      confidenceLevel: selectedMappingObj['Confidence Threshold'],
      forceReview: selectedMappingObj['Force Review'],
      reviewVirtualFolder: reviewVirtFolder,
    }

     this.mappingForm.setValue(data);   
    console.log(this.mappingForm);
  }

  applyFilter(event: Event) {
     let filterValue = (event.target as HTMLInputElement).value;
     this.redactionMappingDataSource.filter = filterValue;
  }

  private filterRedactedCategories(value: string){
    const filterValue = value.toLowerCase();
    return this.redactedCategories.filter(option => option['name'].toLowerCase().includes(filterValue));
  }


  private filterReviewVirtualFolders(value: string) {
    console.log(value);
    const filterValue = value.toLowerCase();
    return this.allVirtualFolderList.filter(option => option['folder_name'].toLowerCase().includes(filterValue));
  }
  
  private filterRedactionProfiles(value: string){
    const filterValue = value.toLowerCase();
    return this.redactionProfiles.filter(option => option['Profile Name'].toLowerCase().includes(filterValue));
  } 

  private filterAllCategories(value: string){
    const filterValue = value.toLowerCase();
    return this.allCategories.filter(option => option['name'].toLowerCase().includes(filterValue));
  } 

  redactedCategorySelected(e) {
    if (e['value'] != undefined && e['value'] != -1) {
      //console.log(this.mappingForm.get('redactedCategory'))
      this.redactedCategoryName = '';
    } else if (e['value'] === -1) {
      //this.resetRedactedCatPerms();
    }

    console.log(this.mappingForm.get('redactedCategory'), this.redactedCategoryName)

    
  }

  reviewVirtualFolderSelected(e) {
    if (e['value'] != undefined && e['value'] != -1) {
      this.reviewVirtualFolderSearch = '';
    }
    console.log(this.mappingForm.get('reviewVirtualFolder'), this.reviewVirtualFolderSearch)
  }

  redactionProfileSelected(e) {
    if (e['value'] != undefined && e['value'] != -1) {
      //console.log(this.mappingForm.get('redactedCategory'))
      this.redactionProfileSearch = '';
    } 
    console.log(this.mappingForm.get('redactionProfile'), this.redactionProfileSearch)
  }

  categorySelected(e) {
    if (e['value'] != undefined && e['value'] != -1) {
      //console.log(this.mappingForm.get('redactedCategory'))
      this.categorySearch = '';
    }
    console.log(this.mappingForm.get('category'), this.categorySearch);
  }

  focusOutFunction(type) {
    
    if(type === 'category') {
      if(this.filteredCategories.length === 0) {
        this.categorySearch = '';
        console.log(type, this.categorySearch)
      }
      
    } else if (type === 'redactionCat') {
      if(this.filteredRedactedCategories.length === 0) {
        this.redactedCategoryName = '';
        console.log(type, this.redactedCategoryName)
      }
    }
    
  }


  setupControls(passedInCat, catType) {
    let tempMetaDataPropsArr = [...passedInCat['meta_data_definition'][0]['properties']]
    if(tempMetaDataPropsArr.findIndex(ele=> ele['name'] === 'Enable Redaction') == -1) {
      tempMetaDataPropsArr.push({
        "name": 'Enable Redaction',
        "required": false,
        "display_in_list": true,
        "data_type": 'bool',
      });
    }

    if(tempMetaDataPropsArr.findIndex(ele=> ele['name'] === 'Redact Doc Type ID') == -1) {
      tempMetaDataPropsArr.push({
        "name": 'Redact Doc Type ID',
        "required": false,
        "display_in_list": false,
        "data_type": 'str',
      });
    }

    if(tempMetaDataPropsArr.findIndex(ele=> ele['name'] === 'Passed Review') == -1) {
      tempMetaDataPropsArr.push({
        "name": 'Passed Review',
        "data_type": "bool",
        "required": false,
        "display_in_list": false,
      });
    }

    passedInCat['meta_data_definition'][0]['properties'] = [...tempMetaDataPropsArr];
    return passedInCat;
  }


  generateVFGroups(category) {
    let reviewCatPerms = category['permissions'];
    let numOfPerms = Object.keys(reviewCatPerms).length
    let vfGroup = []
    for(let i = 0; i < numOfPerms; i++) {
      let tempArr = reviewCatPerms[this.permissionsListForValidations[i]];
      vfGroup = [...vfGroup.concat(tempArr)]
      vfGroup = [...vfGroup.filter((item, pos) => vfGroup.indexOf(item) === pos)]
    }
    return vfGroup;
  }

  async save() {
    //update parent category with permissions and metadata
    let tempCat = this.setupControls(cloneDeep(this.mappingForm.value['category']), 'parent');
    // tempCat['permissions'] = this.permissions();
    console.log(tempCat);
    let updateParentCat;
    if(tempCat['meta_data_definition'][0]['properties'].length === this.mappingForm.value['category']['meta_data_definition'][0]['properties'].length) {
      updateParentCat = {
        "Id": this.mappingForm.value['category']['id'],
        "name": this.mappingForm.value['category']['name'],      
        "permissions": this.mappingForm.value['category']['permissions'],
        "parent_id": this.mappingForm.value['category']['parent_id'],
      }
    } else {
      updateParentCat = {
        "Id": this.mappingForm.value['category']['id'],
        "name": this.mappingForm.value['category']['name'],      
        "permissions": this.mappingForm.value['category']['permissions'],
        "parent_id": this.mappingForm.value['category']['parent_id'],
        "meta_data_definition": {
          "properties": tempCat['meta_data_definition'][0]['properties']
        },
      }
    }
    let resp;
    resp = await this.categoryService.updateCategory(updateParentCat).toPromise();
   

    let redactCatId = null;
    if(resp['success'] === 'True') {
      if(this.redactedCategoryName != '' && this.mappingForm.value['redactedCategory'] === -1) {
        //CREATE A NEW REDACTED CATEGORY
        // alert()
        let finalRedactCatName = this.redactedCategoryName + ' Redacted';
        console.log('Redact cat new creation -- SHOULD NEVER GO HERE')
        redactCatId = await this.createRedactReviewCategory(finalRedactCatName, tempCat,  'redact');
      } else {
        console.log('Redact cat else clause - selected from existing')
        let tempRedactedCat = this.redactedCategories.find(ele => ele['id'] === this.mappingForm.value['redactedCategory']['id'])
        
        let temp = this.setupControls(cloneDeep(tempRedactedCat), 'redact')
        //SELECTED REDACTED, REVIEW CATEGORY
        let updateRedactCat;
        
        if((tempRedactedCat['meta_data_definition'][0]['properties'].length != temp['meta_data_definition'][0]['properties'].length)) {
          //NEED TO UPDATE THE REDACTED CATEGORY with props
          updateRedactCat = {
            "Id": tempRedactedCat['id'],
            "name": tempRedactedCat['name'],      
            "permissions": tempRedactedCat['permissions'], //this.mappingForm.value['copyParentPermissions'] ? tempCat['permissions'] :  tempCat['permissions'], //this.permissionsForRedactCat(),
            "parent_id": tempRedactedCat['parent_id'],
            "meta_data_definition": {
              "properties": temp['meta_data_definition'][0]['properties']
            },
          }
        } else {
          updateRedactCat = {
            "Id": tempRedactedCat['id'],
            "name": tempRedactedCat['name'],      
            "permissions": tempRedactedCat['permissions'], // this.mappingForm.value['copyParentPermissions'] ? tempCat['permissions'] : tempCat['permissions'], //this.permissionsForRedactCat(),
            "parent_id": tempRedactedCat['parent_id'],
          }
        }
        console.log('UpdatRedactCat', updateRedactCat)
        await this.categoryService.updateCategory(updateRedactCat).toPromise();
        redactCatId = tempRedactedCat['id'];
      }

      if (redactCatId != null) {
        let respFolderHierarchyIds = null;
        respFolderHierarchyIds = await this.virtFolderCreationStep();
        if(respFolderHierarchyIds != null) {
          let payload = {
            "catId": tempCat['id'],
            "name": tempCat['name'],
            "redactDestinationId": redactCatId,
            // "reviewDestinationId": reviewCatId,
            "reviewCatId": respFolderHierarchyIds['parentVfId'] + ',' + respFolderHierarchyIds['redactedVfId'] + ',' + respFolderHierarchyIds['reviewVfId'],
            "confidenceThreshold":  this.mappingForm.value['confidenceLevel'] ,
            "forceReview": this.mappingForm.value['forceReview'],
            "redaction_profile_id": this.mappingForm.value['redactionProfile']['Profile ID']
          }
          console.log(payload);
          let obj = null;
          if(this.selectedMappingForEdit != null) {
            obj = this.redactionMappingTableArray.find(ele => ele['Category Id'] === this.selectedMappingForEdit['Category Id']);
          }
          
          if(obj != null && obj != undefined) {
            payload['catId'] = this.selectedMappingForEdit['Category Id'];
            payload['newCatId'] = tempCat['id'];
            console.log('updating redact cat mapping', payload)
            await this.categoryService.updateRedactCatMapping(payload).toPromise();
            
          } else {
            console.log('creating new redact cat mapping', payload)
            await this.categoryService.createRedactCatMapping(payload).toPromise();
            // await this.rulesService.createUpdateRule(payload, null)

          }
        } else {
          console.log("respFolderHierarchyIds is null: ", respFolderHierarchyIds);
        }     
      }
    }

    console.log(this.mappingForm, updateParentCat);
    this.resetValues();
    this.ngOnInit();
  }

  async createVirtualFolders(category_id_array, display_list, folder_name, groups, owner, parent_id, personal, search) {
    let VirtualFolderpayload = {
      "category_id": category_id_array,
      "display_list": display_list,
      "folder_name": folder_name, //NEED TO CHANGE THIS TO ACCOMODATE CAT SELECTION
      "groups": groups, // PROBLEM: NEED TO NOT HAVE THIS HARDCODED
      "owner": owner,
      "parent_id": parent_id,
      "personal": personal,
      "search": search
    }
    console.log(VirtualFolderpayload);
    let respVF = await this.virtualFolderService.createFolder(VirtualFolderpayload).toPromise();
    console.log(respVF)
    return respVF;
  }

  async updateVirtualFolders(virtual_folder_id, category_id_array, display_list, folder_name, groups, owner, parent_id, personal, search) {
    let VirtualFolderpayload = {
      "id": virtual_folder_id,
      "category_id": category_id_array,
      "display_list": display_list,
      "folder_name": folder_name, //NEED TO CHANGE THIS TO ACCOMODATE CAT SELECTION
      "groups": groups, // PROBLEM: NEED TO NOT HAVE THIS HARDCODED
      "owner": owner,
      "parent_id": parent_id,
      "personal": personal,
      "search": search
    }
    console.log(VirtualFolderpayload);
    let respVF = await this.virtualFolderService.updateFolder(VirtualFolderpayload).toPromise();
    console.log(respVF)
    return respVF;
  }

  async virtFolderCreationStep() {
        let tempRedactedCat = this.redactedCategories.find(ele => ele['id'] === this.mappingForm.value['redactedCategory']['id'])
        let vfGroups = this.generateVFGroups(this.mappingForm.value['category']);
        let respVFParent = null;
        let respVFRedacted = null;
        let respVFReview = null;
        
        if(this.reviewVirtualFolderSearch != '' && this.mappingForm.value['reviewVirtualFolder'] === -1) {
          //NEW REVIEW Folder Hierarchy created
      
          console.log('creating new parent VF')
          respVFParent = await this.createVirtualFolders([this.mappingForm.value['category']['id']], ['Passed Review'], this.reviewVirtualFolderSearch, vfGroups, "", 0, false, "meta_data->'properties'->>'Passed Review' = 'false' OR meta_data->'properties'->>'Passed Review' = 'true'" )
          console.log('Successfully Created new parent VF')
          if(respVFParent != null  && respVFParent['id'] != undefined) {
            console.log('creating new redacted VF with parent as ' + respVFParent['id'])
            let vfGroupsRedacted = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
            respVFRedacted = await this.createVirtualFolders([tempRedactedCat['id']], ['Passed Review'], this.reviewVirtualFolderSearch + ' Redacted', vfGroupsRedacted, "", respVFParent['id'], false, "meta_data->'properties'->>'Passed Review' = 'true'")
            console.log('Successfully Created new redacted VF with parent as ' + respVFParent['id'], respVFRedacted)
            if(respVFRedacted != null && respVFRedacted['id'] != undefined) {              
              try{
                console.log('creating new review VF with parent as ' + respVFParent['id'])
                respVFReview = await this.createVirtualFolders([tempRedactedCat['id']], ['Passed Review'], this.reviewVirtualFolderSearch + ' Review', vfGroupsRedacted, "", respVFParent['id'], false, "meta_data->'properties'->>'Passed Review' = 'false'")
                console.log('Successfully Created new review VF with parent as ' + respVFParent['id'], respVFReview)
                let returnObj = {
                  "parentVfId": respVFParent['id'],
                  "redactedVfId": respVFRedacted['id'],
                  "reviewVfId": respVFReview['id']
                }
                console.log(returnObj)
                return returnObj;
              } catch {
                console.log(respVFReview);
                console.log('Error when creating Review virtual folder')
                 //DELETE ALL FOLDERS 
              }              
            } else {
              console.log('Error when creating Redacted virtual folder')
              //DELETE ALL FOLDERS 
            }
          } else {
            console.log('Error when creating parent virtual folder')
          }
        } else {
          console.log('Else statemenet for VF')
          //REVIEW Virtual Folder SELECTED INSTEAD OF CREATED
          let parentVirtfolderName = this.mappingForm.value['reviewVirtualFolder']['folder_name'];
          let parentVfolder = this.allVirtualFolderList.find(ele => ele['folder_name'] === parentVirtfolderName);
          console.log(parentVfolder);
          if(parentVfolder != null && parentVfolder != undefined) {
            //Adding the necessary changes to the parent VF
            console.log('Parent VFolder already present')
            let parentFolderDetails = await this.virtualFolderService.getFolderDetails(parentVfolder['id']).toPromise();
            console.log(parentFolderDetails);
            let tempParentCatId = [...parentFolderDetails['category_id']];
                       
            if(!tempParentCatId.includes(this.mappingForm.value['category']['id'])) {
              tempParentCatId.push(this.mappingForm.value['category']['id']);
            }

            let tempParentFolderGroups = [...parentFolderDetails['groups']];
            let vfGroups = this.generateVFGroups(this.mappingForm.value['category']);
            //REMOVE THE COMMENTS

            for(let i = 0; i < vfGroups.length; i++) {
              if(!tempParentFolderGroups.includes(vfGroups[i])) {
                tempParentFolderGroups.push(vfGroups[i]);
              }
            }
            
            let tempParentDisplayList = [...parentFolderDetails['display_list']];
            if(!tempParentDisplayList.includes('Passed Review')) {
              tempParentDisplayList.push('Passed Review');
            }

            let tempParentSearch = "";
            if(parentFolderDetails['search'].includes('\'Passed Review\' = \'false\'') && parentFolderDetails['search'].includes('\'Passed Review\' = \'true\'')) {
              tempParentSearch = parentFolderDetails['search'];
            } else if (parentFolderDetails['search'].includes('\'Passed Review\' = \'false\'')) {
              tempParentSearch = parentFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'true'";
            } else if (parentFolderDetails['search'].includes('\'Passed Review\' = \'true\'')) {
              tempParentSearch = parentFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'false'";
            } else {
              tempParentSearch = parentFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'false' OR meta_data->'properties'->>'Passed Review' = 'true'";
            }

            let respUpdateParentVF = await this.updateVirtualFolders(parentVfolder['id'],  [...tempParentCatId], tempParentDisplayList, parentVirtfolderName, tempParentFolderGroups, parentFolderDetails['owner'],  parentFolderDetails['parent_id'],  parentFolderDetails['personal'],  tempParentSearch)
            // respVF = await this.virtualFolderService.updateFolder(virtualFolderpayload).toPromise();
            // respVF['id'] =  vfolder['id'];

            //Checking if its a new mapping or an update
            if(this.selectedMappingForEdit === null) {
              //Check if the vf id exists in any of the other mappings as it wont be in this mapping since its new
              let mappingTableWithParentId = this.redactionMappingTableArray.find(ele => ele['parentVfId'] == parentVfolder['id'])
              if(mappingTableWithParentId == undefined) {
                //Not found anywhere so we will create a new hierarchy here
                console.log('Both Child folders not present')
                let vfGroupsRedacted = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                respVFRedacted = null;
                respVFRedacted = await this.createVirtualFolders([tempRedactedCat['id']], ['Passed Review'], parentVirtfolderName + ' Redacted', vfGroupsRedacted, "", parentVfolder['id'], false, "meta_data->'properties'->>'Passed Review' = 'true'")
                console.log(respVFRedacted)
                if(respVFRedacted != null && respVFRedacted['id'] != undefined) {              
                  try{
                    respVFReview = null;
                    respVFReview = await this.createVirtualFolders([tempRedactedCat['id']], ['Passed Review'], parentVirtfolderName + ' Review', vfGroupsRedacted, "", parentVfolder['id'], false, "meta_data->'properties'->>'Passed Review' = 'false'")
                    console.log('Successfully created review folder')
                    let returnObj = {
                      "parentVfId": parentVfolder['id'],
                      "redactedVfId": respVFRedacted['id'],
                      "reviewVfId": respVFReview['id']
                    }
                    console.log(returnObj);
                    return returnObj;
                  } catch {
                    console.log(respVFReview);
                    console.log('Error when creating Review virtual folder')
                    //DELETE ALL FOLDERS
                  }              
                } else {
                  console.log('Error when creating Redacted virtual folder')
                  //DELETE ALL FOLDERS 
                }
              } else {
                //ParentVfId is in mappingTableWithParentId['parentVfId'] but its already updated since we do that right at the start of the else statement
                //reviewVfId is in mappingTableWithParentId['reviewVfId'] and redactedVfId is in mappingTableWithParentId['redactedVfId']
                console.log('Redacted VFolder already present')
                let redactedChildFolderDetails = await this.virtualFolderService.getFolderDetails(mappingTableWithParentId['redactedVfId']).toPromise();
                console.log(redactedChildFolderDetails); 

                let tempRedactedChildFolderCatId = [...redactedChildFolderDetails['category_id']];
                       
                if(!tempRedactedChildFolderCatId.includes(this.mappingForm.value['redactedCategory']['id'])) {
                  tempRedactedChildFolderCatId.push(this.mappingForm.value['redactedCategory']['id']);
                }

                let tempRedactedChildFolderGroups = [...redactedChildFolderDetails['groups']];
                let vfGroups = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                //REMOVE THE COMMENTS

                for(let i = 0; i < vfGroups.length; i++) {
                  if(!tempRedactedChildFolderGroups.includes(vfGroups[i])) {
                    tempRedactedChildFolderGroups.push(vfGroups[i]);
                  }
                }
            
                let tempRedactedChildDisplayList = [...redactedChildFolderDetails['display_list']];
                if(!tempRedactedChildDisplayList.includes('Passed Review')) {
                  tempRedactedChildDisplayList.push('Passed Review');
                }

                let tempRedactedChildSearch = "";
                if(redactedChildFolderDetails['search'].includes('\'Passed Review\' = \'true\'')) {
                  tempRedactedChildSearch = redactedChildFolderDetails['search'];
                } else {
                  tempRedactedChildSearch = redactedChildFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'true'";
                }

                let respUpdateRedactedChildVF = await this.updateVirtualFolders(mappingTableWithParentId['redactedVfId'],  [...tempRedactedChildFolderCatId], tempRedactedChildDisplayList, redactedChildFolderDetails['folder_name'], tempRedactedChildFolderGroups, redactedChildFolderDetails['owner'],  redactedChildFolderDetails['parent_id'],  redactedChildFolderDetails['personal'],  tempRedactedChildSearch)
                console.log(respUpdateRedactedChildVF)
                
                //Update the review virtual folder
                console.log('Review VFolder already present')
                let reviewChildFolderDetails = await this.virtualFolderService.getFolderDetails(mappingTableWithParentId['reviewVfId']).toPromise();
                console.log(reviewChildFolderDetails); 

                let tempReviewChildFolderCatId = [...reviewChildFolderDetails['category_id']];
                       
                if(!tempReviewChildFolderCatId.includes(this.mappingForm.value['redactedCategory']['id'])) {
                  tempReviewChildFolderCatId.push(this.mappingForm.value['redactedCategory']['id']);
                }

                let tempReviewChildFolderGroups = [...reviewChildFolderDetails['groups']];
                vfGroups = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                //REMOVE THE COMMENTS

                for(let i = 0; i < vfGroups.length; i++) {
                  if(!tempReviewChildFolderGroups.includes(vfGroups[i])) {
                    tempReviewChildFolderGroups.push(vfGroups[i]);
                  }
                }
            
                let tempReviewChildDisplayList = [...reviewChildFolderDetails['display_list']];
                if(!tempReviewChildDisplayList.includes('Passed Review')) {
                  tempReviewChildDisplayList.push('Passed Review');
                }

                let tempReviewChildSearch = "";
                if(reviewChildFolderDetails['search'].includes('\'Passed Review\' = \'false\'')) {
                  tempReviewChildSearch = reviewChildFolderDetails['search'];
                } else {
                  tempReviewChildSearch = reviewChildFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'false'";
                }

                let respUpdateReviewChildVF = await this.updateVirtualFolders(mappingTableWithParentId['reviewVfId'],  [...tempReviewChildFolderCatId], tempReviewChildDisplayList, reviewChildFolderDetails['folder_name'], tempReviewChildFolderGroups, reviewChildFolderDetails['owner'],  reviewChildFolderDetails['parent_id'],  reviewChildFolderDetails['personal'],  tempReviewChildSearch)
                console.log(respUpdateReviewChildVF)
                let returnObj = {
                  "parentVfId": mappingTableWithParentId['parentVfId'],
                  "redactedVfId": mappingTableWithParentId['redactedVfId'],
                  "reviewVfId": mappingTableWithParentId['reviewVfId']
                }
                console.log(returnObj);
                return returnObj;
                
              }
            } else {
              //Check in current mapping and if not found in other mappings
              if(this.selectedMappingForEdit['parentVfId'] == parentVfolder['id']) {
                //FOUND IN CURRENT MAPPING
                //ParentVfId is in selectedMappingForEdit['parentVfId'] but its already updated since we do that right at the start of the else statement
                //reviewVfId is in selectedMappingForEdit['reviewVfId'] and redactedVfId is in selectedMappingForEdit['redactedVfId']
                console.log('Redacted VFolder already present in selectedMappingForEdit')
                let redactedChildFolderDetails = await this.virtualFolderService.getFolderDetails(this.selectedMappingForEdit['redactedVfId']).toPromise();
                console.log(redactedChildFolderDetails); 

                let tempRedactedChildFolderCatId = [...redactedChildFolderDetails['category_id']];
                       
                if(!tempRedactedChildFolderCatId.includes(this.mappingForm.value['redactedCategory']['id'])) {
                  tempRedactedChildFolderCatId.push(this.mappingForm.value['redactedCategory']['id']);
                }

                let tempRedactedChildFolderGroups = [...redactedChildFolderDetails['groups']];
                let vfGroups = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                //REMOVE THE COMMENTS

                for(let i = 0; i < vfGroups.length; i++) {
                  if(!tempRedactedChildFolderGroups.includes(vfGroups[i])) {
                    tempRedactedChildFolderGroups.push(vfGroups[i]);
                  }
                }
            
                let tempRedactedChildDisplayList = [...redactedChildFolderDetails['display_list']];
                if(!tempRedactedChildDisplayList.includes('Passed Review')) {
                  tempRedactedChildDisplayList.push('Passed Review');
                }

                let tempRedactedChildSearch = "";
                if(redactedChildFolderDetails['search'].includes('\'Passed Review\' = \'true\'')) {
                  tempRedactedChildSearch = redactedChildFolderDetails['search'];
                } else {
                  tempRedactedChildSearch = redactedChildFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'true'";
                }

                let respUpdateRedactedChildVF = await this.updateVirtualFolders(this.selectedMappingForEdit['redactedVfId'],  [...tempRedactedChildFolderCatId], tempRedactedChildDisplayList, redactedChildFolderDetails['folder_name'], tempRedactedChildFolderGroups, redactedChildFolderDetails['owner'],  redactedChildFolderDetails['parent_id'],  redactedChildFolderDetails['personal'],  tempRedactedChildSearch)
                console.log(respUpdateRedactedChildVF); 
                
                //Update the review virtual folder
                console.log('Review VFolder already present')
                let reviewChildFolderDetails = await this.virtualFolderService.getFolderDetails(this.selectedMappingForEdit['reviewVfId']).toPromise();
                console.log(reviewChildFolderDetails); 

                let tempReviewChildFolderCatId = [...reviewChildFolderDetails['category_id']];
                       
                if(!tempReviewChildFolderCatId.includes(this.mappingForm.value['redactedCategory']['id'])) {
                  tempReviewChildFolderCatId.push(this.mappingForm.value['redactedCategory']['id']);
                }

                let tempReviewChildFolderGroups = [...reviewChildFolderDetails['groups']];
                vfGroups = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                //REMOVE THE COMMENTS

                for(let i = 0; i < vfGroups.length; i++) {
                  if(!tempReviewChildFolderGroups.includes(vfGroups[i])) {
                    tempReviewChildFolderGroups.push(vfGroups[i]);
                  }
                }
            
                let tempReviewChildDisplayList = [...reviewChildFolderDetails['display_list']];
                if(!tempReviewChildDisplayList.includes('Passed Review')) {
                  tempReviewChildDisplayList.push('Passed Review');
                }

                let tempReviewChildSearch = "";
                if(reviewChildFolderDetails['search'].includes('\'Passed Review\' = \'false\'')) {
                  tempReviewChildSearch = reviewChildFolderDetails['search'];
                } else {
                  tempReviewChildSearch = reviewChildFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'false'";
                }
                  //WE NEED TO GET RID OF THE PREVIOUS CATEGORY_IDS THAT MATCHES THE PREVIOUS REDACTED_CAT IF REDACTED CAT IS CHANGED 
                let respUpdateReviewChildVF = await this.updateVirtualFolders(this.selectedMappingForEdit['reviewVfId'],  [...tempReviewChildFolderCatId], tempReviewChildDisplayList, reviewChildFolderDetails['folder_name'], tempReviewChildFolderGroups, reviewChildFolderDetails['owner'],  reviewChildFolderDetails['parent_id'],  reviewChildFolderDetails['personal'],  tempReviewChildSearch)
                console.log(respUpdateReviewChildVF)
                let returnObj = {
                  "parentVfId": this.selectedMappingForEdit['parentVfId'],
                  "redactedVfId": this.selectedMappingForEdit['redactedVfId'],
                  "reviewVfId": this.selectedMappingForEdit['reviewVfId']
                }
                console.log(returnObj);
                return returnObj;
                             
              } else {
                console.log('Not found in Current mapping so now searching in other mappings')
                let mappingTableWithParentId = this.redactionMappingTableArray.find(ele => ele['parentVfId'] == parentVfolder['id'])
                if(mappingTableWithParentId == undefined) {
                  //Not found anywhere so we will create a new hierarchy here
                  console.log('Both Child folders not present ')
                  let vfGroupsRedacted = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                  respVFRedacted = null;
                  respVFRedacted = await this.createVirtualFolders([tempRedactedCat['id']], ['Passed Review'], parentVirtfolderName + ' Redacted', vfGroupsRedacted, "", parentVfolder['id'], false, "meta_data->'properties'->>'Passed Review' = 'true'")
                  console.log(respVFRedacted)
                  if(respVFRedacted != null && respVFRedacted['id'] != undefined) {              
                    try{
                      respVFReview = null;
                      respVFReview = await this.createVirtualFolders([tempRedactedCat['id']], ['Passed Review'], parentVirtfolderName + ' Review', vfGroupsRedacted, "", parentVfolder['id'], false, "meta_data->'properties'->>'Passed Review' = 'false'")
                      console.log('Successfully created review folder')
                      let returnObj = {
                        "parentVfId": parentVfolder['id'],
                        "redactedVfId": respVFRedacted['id'],
                        "reviewVfId": respVFReview['id']
                      }
                      console.log(returnObj);
                      return returnObj;
                    } catch {
                      console.log(respVFReview);
                      console.log('Error when creating Review virtual folder')
                      //DELETE ALL FOLDERS
                    }              
                  } else {
                    console.log('Error when creating Redacted virtual folder')
                    //DELETE ALL FOLDERS 
                  }
                } else {
                  //ParentVfId is in mappingTableWithParentId['parentVfId'] but its already updated since we do that right at the start of the else statement
                  //reviewVfId is in mappingTableWithParentId['reviewVfId'] and redactedVfId is in mappingTableWithParentId['redactedVfId']
                  console.log('Redacted VFolder already present')
                  console.log('ParentVfId is in mappingTableWithParentId[parentVfId] but its already updated since we do that right at the start of the else statement. reviewVfId is in mappingTableWithParentId[reviewVfId] and redactedVfId is in mappingTableWithParentId[redactedVfId]')
                  let redactedChildFolderDetails = await this.virtualFolderService.getFolderDetails(mappingTableWithParentId['redactedVfId']).toPromise();
                  console.log(redactedChildFolderDetails); 
  
                  let tempRedactedChildFolderCatId = [...redactedChildFolderDetails['category_id']];
                         
                  if(!tempRedactedChildFolderCatId.includes(this.mappingForm.value['redactedCategory']['id'])) {
                    tempRedactedChildFolderCatId.push(this.mappingForm.value['redactedCategory']['id']);
                  }
  
                  let tempRedactedChildFolderGroups = [...redactedChildFolderDetails['groups']];
                  let vfGroups = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                  //REMOVE THE COMMENTS
  
                  for(let i = 0; i < vfGroups.length; i++) {
                    if(!tempRedactedChildFolderGroups.includes(vfGroups[i])) {
                      tempRedactedChildFolderGroups.push(vfGroups[i]);
                    }
                  }
              
                  let tempRedactedChildDisplayList = [...redactedChildFolderDetails['display_list']];
                  if(!tempRedactedChildDisplayList.includes('Passed Review')) {
                    tempRedactedChildDisplayList.push('Passed Review');
                  }
  
                  let tempRedactedChildSearch = "";
                  if(redactedChildFolderDetails['search'].includes('\'Passed Review\' = \'true\'')) {
                    tempRedactedChildSearch = redactedChildFolderDetails['search'];
                  } else {
                    tempRedactedChildSearch = redactedChildFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'true'";
                  }
  
                  let respUpdateRedactedChildVF = await this.updateVirtualFolders(mappingTableWithParentId['redactedVfId'],  [...tempRedactedChildFolderCatId], tempRedactedChildDisplayList, redactedChildFolderDetails['folder_name'], tempRedactedChildFolderGroups, redactedChildFolderDetails['owner'],  redactedChildFolderDetails['parent_id'],  redactedChildFolderDetails['personal'],  tempRedactedChildSearch)
                  console.log(respUpdateRedactedChildVF)
                  
                  //Update the review virtual folder
                  console.log('Review VFolder already present')
                  let reviewChildFolderDetails = await this.virtualFolderService.getFolderDetails(mappingTableWithParentId['reviewVfId']).toPromise();
                  console.log(reviewChildFolderDetails); 
  
                  let tempReviewChildFolderCatId = [...reviewChildFolderDetails['category_id']];
                         
                  if(!tempReviewChildFolderCatId.includes(this.mappingForm.value['redactedCategory']['id'])) {
                    tempReviewChildFolderCatId.push(this.mappingForm.value['redactedCategory']['id']);
                  }
  
                  let tempReviewChildFolderGroups = [...reviewChildFolderDetails['groups']];
                  vfGroups = this.generateVFGroups(this.mappingForm.value['redactedCategory']);
                  //REMOVE THE COMMENTS
  
                  for(let i = 0; i < vfGroups.length; i++) {
                    if(!tempReviewChildFolderGroups.includes(vfGroups[i])) {
                      tempReviewChildFolderGroups.push(vfGroups[i]);
                    }
                  }
              
                  let tempReviewChildDisplayList = [...reviewChildFolderDetails['display_list']];
                  if(!tempReviewChildDisplayList.includes('Passed Review')) {
                    tempReviewChildDisplayList.push('Passed Review');
                  }
  
                  let tempReviewChildSearch = "";
                  if(reviewChildFolderDetails['search'].includes('\'Passed Review\' = \'false\'')) {
                    tempReviewChildSearch = reviewChildFolderDetails['search'];
                  } else {
                    tempReviewChildSearch = reviewChildFolderDetails['search'] + " OR meta_data->'properties'->>'Passed Review' = 'false'";
                  }
  
                  let respUpdateReviewChildVF = await this.updateVirtualFolders(mappingTableWithParentId['reviewVfId'],  [...tempReviewChildFolderCatId], tempReviewChildDisplayList, reviewChildFolderDetails['folder_name'], tempReviewChildFolderGroups, reviewChildFolderDetails['owner'],  reviewChildFolderDetails['parent_id'],  reviewChildFolderDetails['personal'],  tempReviewChildSearch)
                  console.log(respUpdateReviewChildVF); 
                  let returnObj = {
                    "parentVfId": mappingTableWithParentId['parentVfId'],
                    "redactedVfId": mappingTableWithParentId['redactedVfId'],
                    "reviewVfId": mappingTableWithParentId['reviewVfId']
                  }
                  console.log(returnObj);
                  return returnObj;
                  
                }
      
              }
              
            }
          } else {
            console.log('Parent Virtual folder not found in list')
          }
        }
  }

  async deleteMapping(id) {
    this.mappingToBeDeleted = id;
    this.deleteMappingPopupRef = this.dialog.open(this.deleteMappingPopup);    
  }

  async confirmDeleteMapping(action) {
    if(action === 'delete') {
      if(this.mappingToBeDeleted != null || this.mappingToBeDeleted != undefined) {
        await this.categoryService.deleteMappingEntry(this.mappingToBeDeleted).toPromise();
        if(this.deleteMappingPopupRef != null || this.deleteMappingPopupRef != undefined) {
          this.deleteMappingPopupRef.close();
        }
        this.resetValues();
        this.ngOnInit();
      }     
    }
    
    if(this.deleteMappingPopupRef != null || this.deleteMappingPopupRef != undefined) {
      this.deleteMappingPopupRef.close();
    }
  }

  async createRedactReviewCategory(name, parentCategory, catType) {
    var newCatReq = {
      "name": name,
      "meta_data_definition":  [
        {
          "properties": parentCategory['meta_data_definition'][0]['properties']
        }
      ],
      "permissions": this.mappingForm.value['copyParentPermissions'] ? parentCategory['permissions'] : parentCategory['permissions'],//catType == 'redact' ? this.permissionsForRedactCat() : this.permissionsForRedactCat(),
      "parent_id": parentCategory['id']
    }
    console.log(newCatReq);
    let resp = await this.categoryService.createCategory(newCatReq).toPromise();
    return resp['id'];
  }

  resetValues() {
    this.enableNewMappingPage = false;
    this.enableUpdateMappingPage = false;
    this.selectedMappingForEdit = null;
    this.mappingForm ? this.mappingForm.reset() : null;
    this.button = 'Save';

    this.copiedGroups = null;
    this.copiedGroupsForCat = null;
    this.commonPermissions = [];
    this.displaySubCatPerms = true;

    this.mappingToBeDeleted = null;
    this.redactedCategoryName= '';
    //this.reviewCategoryName = '';
    this.redactionProfileSearch = '';
    this.categorySearch = '';
    // redactionMappingTableArray = [];
    // redactionMappingDataSource = new MatTableDataSource(this.redactionMappingTableArray);
    // isAdmin: boolean = false;
    // currentUser: User;
    // userGroups: string[];
    // displayedColumns: string[] = ['catName', 'redactedCatName', 'reviewCatName', 'redactionProfile', 'confidenceLevel', 'forceReview', 'actions'];
    // allCategories: Observable<Category[]>;
    // filteredCategories;
    // redactedCategories;
    // filteredRedactedCategories;
    // reviewCategories;
    // filteredReviewCategories;
    // redactionProfiles = [];
    // filteredRedactionProfiles;
    // usersList = [];
    // allVirtualFolderList = [];
    // deleteMappingPopupRef = null;
    
    // differ: any;
    
    // permissionName: string
    // permissionsList: string[] = ["Add Document", "Update Document", "Delete Document", "View Document", "Get Document", "Create Category", "Get Category", "Update Category", "Delete Category", "Compliance", "Redact Document"]
    // permissionsListForValidations: string[] = ["add_document", "update_document", "delete_document", "view_document", "get_document", "create_category", "get_category", "update_category", "delete_category", "compliance", "redact_document"];
    // trialArray = [ 1, 2, 3];
  }

  back() {
    this.resetValues();
  }



}
